import { jsx as _jsx } from "react/jsx-runtime";
import { useHoverOverlay } from "./HoverOverlayProvider";
export default function GlobalHoverOverlay() {
    const { active } = useHoverOverlay();
    if (!active)
        return null;
    return _jsx("div", { className: "global-hover-overlay" });
}
